import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel'
import React from "react";
import "./InfoCarouselComponent.scss";
import { IInfoCarouselProps } from "./InfoCarouselInterfaces.types";


function InfoCarouselComponent(props: IInfoCarouselProps) {

  return (
    <div>
      <Carousel showIndicators={(props.items.length > 1)} dynamicHeight={true} showThumbs={false} showArrows={false} showStatus={false}>
        {
          props.items.map((item) => (
            <div key={item} style={{}}>
              <img src={item} alt={item} style={{
                height: '100%', width: '100%',
                boxShadow: '0px 4px 10px 0px rgba(143, 171, 195, 0.30)',
                borderRadius: '5px'
              }} />
            </div>
          ))
        }
      </Carousel>
    </div>
  );
}

export default InfoCarouselComponent;
